import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import compose from 'recompose/compose'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import startCase from 'lodash/startCase'
import { RootMeta } from 'components/Meta'
import SubmitMentionForm from 'components/forms/SubmitMentionForm'
import * as actions from 'actions/app'

const styles = (theme) => ({
  root: {
    width: '100%',
    minHeight: '85vh',
    padding: 20,
    [theme.breakpoints.down('xs')]: {
      padding: 15,
    },
  },
  header: {
    textTransform: 'none',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.1em',
    },
  },
  subheader: {
    textTransform: 'none',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8m',
    },
  },
})

const SubmitMentionPage = ({ classes, data, submitForm, sendAlert }) => {
  const {
    site: { siteMetadata },
    allMarkdownRemark,
  } = data

  const workoutSuggestions = allMarkdownRemark.edges.map(({ node }) => {
    const value = node.fields.slug.replace(/\//g, '')
    return {
      label: startCase(value),
      value,
    }
  })

  const onSubmit = (values, _, { reset }) =>
    submitForm({ formName: 'submit_mention_form', values })
      .then(() => {
        console.log(values)
        reset()
        return sendAlert({
          message:
            'Your mention was sent! Please allow us at least one business day to process the mention.',
          type: 'success',
        })
      })
      .catch((error) => {
        if (error) {
          return sendAlert({
            message: error.message,
            type: 'error',
          })
        } else {
          return sendAlert({
            message:
              'An error occurred while submitting. Please try again later.',
            type: 'error',
          })
        }
      })

  return (
    <div className={classes.root}>
      <RootMeta
        title={`Submit A Workout Mention | ${siteMetadata.siteName}`}
        url={siteMetadata.siteUrl}
        description={siteMetadata.siteDescription}
        breadCrumb={[
          {
            url: siteMetadata.siteUrl + '/submit-mention',
            name: 'Submit Workout Mention',
          },
        ]}
      />
      <Typography className={classes.header} variant="headline">
        You are submitting a mention for a workout exercise.
      </Typography>
      <Typography
        className={classes.subheader}
        variant="subheading"
        paragraph
        gutterBottom
      >
        Once a <em>mention</em> is accepted they will appear in the{' '}
        <Link to="/weight-loss-workouts">workouts</Link> section.
      </Typography>

      <SubmitMentionForm
        onSubmit={onSubmit}
        workoutSuggestions={workoutSuggestions}
      />
    </div>
  )
}

SubmitMentionPage.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
}

// prettier-ignore
// eslint-disable-next-line
export const query = graphql`
  query SubmitMentionPageQuery {
    site {
      siteMetadata {
        siteName
        siteUrl
        siteDescription
      }
    }
    allMarkdownRemark(
      filter: { frontmatter: { pageType: { eq: "workout" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
        }
      }
    }
  }
`

export default compose(
  withStyles(styles),
  connect(null, {
    submitForm: actions.submitForm,
    sendAlert: actions.sendAlert,
  }),
)(SubmitMentionPage)



// WEBPACK FOOTER //
// ./src/pages/submit-mention.js